import React, { useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { getItems } from "../../../store/inventories/api";
import SearchSelect from "../../generics/SearchSelect";
import PropTypes from "prop-types";

const LacksRefereceError = ({ setSelectedItem, setOfferItemPerLb }) => {
  const [item, setItem] = useState(null);
  const [isPerLb, setIsPerLb] = useState(false);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const searchItems = (input, callback) => {
    setIsLoadingItems(true);
    let options = [];
    getItems(input, null, null, null, null, true)
      .then((r) => {
        r.data.results.map((item) => {
          options.push({ value: item.id, label: item.name });
        });
        callback(options);
      })
      .catch((err) => {
        setIsLoadingItems(false);
      });
  };

  const handleChangeItem = (event) => {
    setIsLoadingItems(false);
    setSelectedItem(event);
    setItem(event);
  };

  const handleChangeIsPerLb = (checked) => {
    setIsPerLb(checked);
    setOfferItemPerLb(checked);
  };

  return (
    <div>
      <FormGroup className="mt-1 ">
        <Label for="exampleFile">Item:</Label>
        <SearchSelect onChange={handleChangeItem} getOptions={searchItems} isLoading={isLoadingItems} value={item} classInput="col-sm-4" />
        <Label>Set offer item as per lb:</Label>
        <input
          type="checkbox"
          style={{ marginLeft: "5px" }}
          checked={isPerLb}
          onChange={(event) => handleChangeIsPerLb(event.target.checked)}
        />
      </FormGroup>
    </div>
  );
};

LacksRefereceError.propTypes = {
  setSelectedItem: PropTypes.func,
};

export default LacksRefereceError;
